"use client";
import { Add, Minus } from "iconsax-react";
import React, { useEffect } from "react";
import Image from "next/image";
import DeleteBaasketIcon from "../Svg/DeleteBaasketIcon";
import useCartStore from "@/store/store";
import { CardBasketType } from "@/types/productType";
import useSoftSetting from "@/hooks/useSoftSetting";

function CardBasket({ hasCounter, product, hasMax }: CardBasketType) {
  const updateQuantity = useCartStore((state) => state.updateQuantity);
  const removeFromCard = useCartStore((state) => state.removeFromCard);
  const { loadCard } = useCartStore();
  const { data } = useSoftSetting;
  const increment = () => {
    const newQuantity = Math.min(
      (product?.quantity ?? 1) + 1,
      Number(product?.stockThreshold)
    );
    updateQuantity(
      product.productId,
      product.variantId,
      newQuantity,
      Number(product?.stockThreshold)
    );
  };

  const decrement = () => {
    const currentQuantity = product?.quantity ?? 1;
    const newQuantity = currentQuantity - 1;
    if (newQuantity < 1) {
      deleteProductHandler();
    } else {
      updateQuantity(
        product.productId,
        product.variantId,
        newQuantity,
        Number(product?.stockThreshold)
      );
    }
  };
  useEffect(() => {
    loadCard();
  }, [loadCard]);
  const deleteProductHandler = () => {
    if (product?.variantId) {
      removeFromCard(product.variantId);
    }
  };
  return (
    <div className="py-6 border-b  last:border-b-0 border-ws-gray-300 flex flex-col overflow-x-hidden">
      <div className="flex justify-between items-center gap-5">
        <div className="flex items-center gap-2 sm:gap-4">
          <div className="w-[70px] sm:w-[100px] g-[60px] sm:h-[90px] rounded-2xl">
            <Image
              priority
              fetchPriority="high"
              sizes="100vw"
              width={100000}
              height={3000}
              src={product?.image ?? product?.imageName}
              alt=""
              unoptimized
              className="w-full h-full object-cover rounded-xl border-2 border-ws-gray-300"
            />
          </div>
          <div className="h-full flex flex-col justify-between">
            <h2 className="self-start text-ws-gray-700 font-medium sm:text-base text-sm w-[70px]   sm:w-[150px]">
              {product?.productName}
            </h2>
            <span>
              {product?.quantity === product?.stockThreshold ? (
                <span className="text-xs text-ws-coral-blush-400">
                  {hasMax ? "حداکثر" : ""}
                </span>
              ) : (
                ""
              )}
            </span>
          </div>
        </div>
        <div className="flex flex-col items-end ">
          <span className="flex gap-1 items-center">
            <span className="flex sm:flex-row flex-col gap-2 items-center">
              <span className=" sm:block flex items-center gap-1">
                {product?.originalPrice === product?.salePrice ? (
                  ""
                ) : product?.originalPrice === 0 ? (
                  ""
                ) : (
                  <>
                    <span className="text-ws-gray-400 !font-semibold sm:text-sm text-sm  line-through num-vazir">
                      {product?.originalPrice.toLocaleString()}
                    </span>
                    <span className="sm:hidden inline-block text-ws-gray-500 !font-semibold sm:text-base text-sm">
                      {data?.currencyUnit}
                    </span>
                  </>
                )}
              </span>
              <span className=" flex items-center gap-1">
                <span className="text-ws-gray-800  sm:text-base text-sm num-vazir font-bold">
                  {product?.salePrice.toLocaleString()}
                </span>
                <span className="text-ws-gray-500 font-semibold sm:text-base text-sm">
                  {data?.currencyUnit}
                </span>
              </span>
            </span>
          </span>
          {hasCounter ? (
            ""
          ) : (
            <span className="flex items-center gap-1 font-bold text-ws-gray-800">
              <span className="num-vazir">{product?.count}</span>
              <span>عدد</span>
            </span>
          )}

          {hasCounter ? (
            <div className="flex items-center gap-5">
              <div className="inline-flex items-center border border-ws-gray-300 bg-ws-white-100  rounded-xl ltr sm:px-2 py-1">
                <button
                  type="button"
                  onClick={decrement}
                  className="w-6 h-6 flex items-center justify-center hover:text-gray-600 transition-colors"
                  aria-label="کاهش تعداد"
                >
                  <Minus
                    color="#4B5D6C"
                    className="w-4 h-4 font-bold path-stroke"
                  />
                </button>
                <span className="w-12 flex justify-center rtl items-center text-center font-medium  py-2 text-sm num-vazir">
                  {`${product?.quantity} ${product?.unitCounting}`}
                </span>

                <button
                  type="button"
                  onClick={increment}
                  className="w-6 h-6 flex items-center justify-center hover:text-gray-600 transition-colors"
                  aria-label="افزایش تعداد"
                >
                  <Add
                    color="#4B5D6C"
                    className="w-4 h-4 font-bold path-stroke"
                  />
                </button>
              </div>

              <span
                onClick={deleteProductHandler}
                className="border delete-basket-icon flex items-center border-ws-gray-300 bg-ws-white-100  rounded-xl ltr py-3 sm:py-3 px-2 sm:px-3 cursor-pointer"
              >
                <DeleteBaasketIcon className="" />
              </span>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default CardBasket;
